/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  timezone: 'Africa/Abidjan',
}

const timezoneSlice = createSlice({
  name: 'timezone',
  initialState,
  reducers: {
    setTimezone: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload
    },
  },
})

export default timezoneSlice.reducer
export const { setTimezone } = timezoneSlice.actions
